module.exports = ["EthereumCityERC20TokenMinter"];